<template>
    <div>
        <v-snackbar v-model="snackbar.visible"
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    top>
            {{snackbar.text}}
        </v-snackbar>
    <v-data-table
            :items="services"
            :headers="headers"
            item-key="id"
            :search="search"
            :custom-filter="customSearch"
            @click:row="showDetail"
            :loading="loading">
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Leistung Suchen"
                        single-line
                        hide-details
                        solo
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2" @click="createService">Neue Leistung</v-btn>
                <ServiceModal v-model="editedService" :open="dialog" :title="dialogTitle" v-on:close="() => dialog = false" v-on:save="save"/>
            </v-toolbar>
        </template>

        <template v-slot:item.description="{ item }">
            {{getShortText(item.description)}}
        </template>
        <template v-slot:item.startDate="{ item }">
            {{getDate(item.startDate)}}
        </template>
        <template v-slot:item.endDate="{ item }">
            {{getDate(item.endDate)}}
        </template>
        <template v-slot:item.serviceType="{ item }">
            {{item.serviceType.name}}
        </template>
        <template v-slot:item.account="{ item }">
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <router-link :to="'/users/'+item.accountId">
                            {{item.account.firstname}}
                            {{item.account.lastname}}
                        </router-link>
                    </div>
                </template>
                <span>{{item.account.email}}</span>
            </v-tooltip>
        </template>
        <template v-slot:item.confirmed="{ item }">
            <v-simple-checkbox v-model="item.confirmed" disabled></v-simple-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon
                    class="mr-2"
                    @click.stop="editService(item)"
            >
                mdi-pencil
            </v-icon>
            <v-icon
                    color="red"
                    @click.stop="deleteService(item)"
            >
                mdi-delete
            </v-icon>
        </template>
    </v-data-table>
    </div>
</template>

<script>
    import ServiceModal from "./ServiceModal";
    import {serviceService} from "../services/serviceService";
    import {accountService} from "@/services/accountService";

    export default {
        name: "ServiceTable",
        components: {ServiceModal},
        props: ["query"],
        data: () => {
            return {
                loading: true,
                dialog: false,
                search: "",
                services: [],
                headers: [
                    {
                        text: "Beschreibung",
                        value: "description"
                    },
                    {
                        text: "Startdatum",
                        value: "startDate"
                    },
                    {
                        text: "Enddatum",
                        value: "endDate"
                    },
                    {
                        text: "Leistungstyp",
                        value: "serviceType"
                    },
                    {
                        text: "Ersteller",
                        value: "account"
                    },
                    {
                        text: "Visiert",
                        value: "confirmed"
                    },
                    {text: 'Aktionen', value: 'actions', sortable: false},
                ],
                editedIndex: -1,
                editedService: {
                    id: 0,
                    description: "",
                    confirmed: false,
                    startDate: new Date().toISOString().substr(0, 10),
                    endDate: new Date().toISOString().substr(0, 10),
                    shortActivityCount: 0,
                    shortActivityVolunteerCount: 0,
                    halfDayActivityCount: 0,
                    halfDayActivityVolunteerCount: 0,
                    fullDayActivityCount: 0,
                    fullDayActivityVolunteerCount: 0,
                    serviceType: null,
                    serviceTypeId: 0,
                    account: null,
                    accountId: 0
                },
                defaultService: {
                    id: 0,
                    description: "",
                    confirmed: false,
                    startDate: new Date().toISOString().substr(0, 10),
                    endDate: new Date().toISOString().substr(0, 10),
                    shortActivityCount: 0,
                    shortActivityVolunteerCount: 0,
                    halfDayActivityCount: 0,
                    halfDayActivityVolunteerCount: 0,
                    fullDayActivityCount: 0,
                    fullDayActivityVolunteerCount: 0,
                    serviceType: null,
                    serviceTypeId: 0,
                    account: null,
                    accountId: 0
                },
                snackbar: {
                    visible: false,
                    text: "",
                    timeout: 5000,
                    color: ""
                },
            };
        },
        computed: {
            dialogTitle () {
                return this.editedIndex === -1 ? "Neue Leistung" : "Leistung bearbeiten"
            },
        },
        methods: {
            customSearch (value, search, item) {
              search = search.toLowerCase();
              return item && (item.description.toLowerCase().includes(search) ||
                  (item.account && (item.account.firstname.toLowerCase() + " " + item.account.lastname.toLowerCase()).includes(search)) ||
                      item.serviceType && item.serviceType.name.toLowerCase().includes(search)
              );
            },
            save() {
                let service = Object.assign({}, this.editedService)
                service.startDate = this.editedService.startDate + "T00:00:00";
                service.endDate = this.editedService.endDate + "T00:00:00";
                service.account = null;
                service.serviceType = null;
                let self = this;
                if (this.editedIndex > -1) {
                    serviceService.updateService(service).then((response) => {
                        Object.assign(self.services[self.editedIndex], response)
                        self.fetchServices();
                        self.dialog = false;
                      self.clearModal();
                    }).catch((error) => {
                        if(error.response.status === 401) {
                            self.showSnackbar(error.response.data)
                        } else if(error.response.status === 400) {
                          self.showSnackbar(error.response.data);
                        } else {
                          self.showSnackbar("Ein Fehler ist aufgetreten");
                          console.log(error);
                        }
                    })
                } else {
                    serviceService.createService(service).then((response) => {
                        self.services.push(response)
                        self.fetchServices();
                        self.dialog = false
                      self.clearModal();
                    }).catch((error) => {
                        if(error.response.status === 401) {
                            self.showSnackbar(error.response.data)
                        } else if(error.response.status === 400) {
                            self.showSnackbar(error.response.data);
                        } else {
                          self.showSnackbar("Ein Fehler ist aufgetreten");
                          console.log(error);
                        }
                    })
                }
            },
          clearModal() {
              this.editedService = Object.assign({}, this.defaultService);
              this.editedIndex = -1;
          },
          createService() {
            this.clearModal();
            this.dialog = true;
          },
            editService(service) {
              this.clearModal();
                this.editedIndex = this.services.indexOf(service)
                this.editedService = Object.assign({}, service)
                this.editedService.startDate = this.editedService.startDate.substr(0, 10)
                this.editedService.endDate = this.editedService.endDate.substr(0, 10)
                this.dialog = true;
            },
            deleteService(service) {
                if(!confirm("Willst du die Leistung " + service.description + " wirklich löschen?"))
                    return;
                let self = this;
                serviceService.deleteServiceById(service.id).then(() => {
                    self.fetchServices();
                });
                return service
            },
            getShortText(text) {
                if (text.length > 15) {
                    var trimmedString = text.substr(0, 15);

                    return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))) + "..."
                }
                return text
            },
            showDetail(service) {
                this.$router.push("/services/"+service.id);
            },
            getDate(date) {
                return new Date(date).toLocaleDateString('de-CH');
            },
            fetchServices() {
                let self = this;
                if(this.query == "")
                  serviceService.getServices().then(response => {
                      self.services = response;
                      self.loading = false;
                  }).catch((error) => {
                    console.log(error);
                    accountService.refreshToken().then(() => this.fetchServices()).catch(() => accountService.signOut())
                  })
              else
                  serviceService.getQuery(this.query).then(response => {
                    self.services = response;
                    self.loading = false;
                  }).catch((error) => {
                    console.log(error);
                    accountService.refreshToken().then(() => this.fetchUsers()).catch(() => accountService.signOut())
                  })
            },
            showSnackbar(text, color = "red") {
                this.snackbar.text = text;
                this.snackbar.color = color;
                this.snackbar.visible = true;
            }
        },
        created() {
            this.fetchServices();
        }
    }
</script>

<style scoped>

</style>
